import { Component, Input } from '@angular/core';
import { CorrectionItem } from '../../../models/CorrectionItem';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AnimationItem } from 'lottie-web';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'correction',
  standalone: true,
  imports: [CommonModule, TranslateModule, LottieComponent],
  templateUrl: './correction.component.html',
  styleUrl: './correction.component.scss',
  animations: [
    trigger('correctionAnimation', [
      state('hidden', style({ opacity: 0, transform: 'scale(0.8)' })),
      state('visible', style({ opacity: 1, transform: 'scale(1)' })),
      transition('hidden => visible', animate('300ms ease-out')),
      transition('visible => hidden', animate('300ms ease-in')),
    ]),
  ],
})
export class CorrectionComponent {
  @Input() correction: CorrectionItem[];
  @Input() onlyPicked: boolean;
  @Input() isVisible: boolean = false;

  goodAnswerOptions: AnimationOptions = {
    path: '/assets/lottie/like.json',
    loop: false,
    autoplay: true,
  };
  private gaAnimationItem!: AnimationItem;
  badAnswerOptions: AnimationOptions = {
    path: '/assets/lottie/bad_answer.json',
    loop: false,
    autoplay: true,
  };
  private baAnimationItem!: AnimationItem;
  private delayMs = 2000;

  getAnswersToDisplay(): CorrectionItem[] {
    if (this.onlyPicked) {
      return this.correction.filter((elt) => elt.picked);
    }

    if (this.correction.filter((elt) => elt.correct).length === this.correction.length) {
      return this.correction;
    } else if (this.correction.filter((elt) => !elt.correct).length === this.correction.length) {
      return this.correction;
    } else {
      return this.correction.filter((elt) => !elt.correct);
    }
  }

  isCorrectionWrong(): boolean {
    return this.correction.filter((elt) => !elt.correct).length > 0;
  }

  shouldDisplayUniqueAnswerType(): boolean {
    if (this.onlyPicked) {
      return this.correction.filter((elt) => elt.picked).length > 1;
    } else {
      return this.correction.length > 1;
    }
  }

  getBorder(): any {
    const color = this.isCorrectionWrong() ? '#e84243' : '#0fc461';
    let obj: any = {
      border: `solid 8px ${color}`,
    };

    return obj;
  }

  gaAnimationCreated(animationItem: AnimationItem): void {
    this.gaAnimationItem = animationItem;
    this.gaAnimationItem.addEventListener('complete', this.gaOnComplete.bind(this));
  }

  gaOnComplete(): void {
    setTimeout(() => {
      this.gaAnimationItem.goToAndPlay(0, true);
    }, this.delayMs);
  }

  baAnimationCreated(animationItem: AnimationItem): void {
    this.baAnimationItem = animationItem;
    this.baAnimationItem.addEventListener('complete', this.baOnComplete.bind(this));
  }

  baOnComplete(): void {
    setTimeout(() => {
      this.baAnimationItem.goToAndPlay(0, true);
    }, this.delayMs);
  }
}
